import { useCallback } from "react";

import { Action, StencilType } from "../../types";
import { refreshMovements, sliceItemUpdate } from "../../utils";
import { UpdateFrameStencils } from "./use-update-frame-stencils";

export interface UpdateMovementTimeProps {
  actionId: string;
  startTime: number;
  endTime: number;
}

export type UpdateMovementTimeFunc = (props: UpdateMovementTimeProps) => void;

export const useUpdateMovementTime = (updateFrameStencils: UpdateFrameStencils) => {
  return useCallback<UpdateMovementTimeFunc>(
    ({ actionId, startTime, endTime }) => {
      // frame stencils set state
      updateFrameStencils((prevState) => {
        // if previous state is not found, return previous state
        if (!prevState) return prevState;

        const action = prevState.find(
          (stencil): stencil is Action => stencil.id === actionId && stencil.stencilType === StencilType.ACTION
        );

        return action
          ? refreshMovements(sliceItemUpdate({ item: { ...action, startTime, endTime }, arr: prevState }))
          : prevState;
      });
    },
    [updateFrameStencils]
  );
};
